"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultData = void 0;
exports.defaultData = {
    // merchant_key: '',
    // checkout_amount: ,
    currency_code: 'NGN',
    // first_name: string,
    // last_name: string,
    // email_address: string,
    // phone_number: string
};
